export const useMonthPeriod = (year: number, month: number) => {
  if (month > 12 || month < 0) {
    throw new Error('wrong month index');
  }

  return [new Date(year, month, 1), new Date(year, month + 1, 0)];
};

export const useShortDateFormat = (date: Date) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const day = date.getDate();

  const monthIndex = date.getMonth();
  const monthName = monthNames[monthIndex];

  const year = date.getFullYear().toString().substring(2);

  return `${day} ${monthName} ${year}`;
};

export const useDateFormat = (date: Date) => {
  const year = date.getFullYear();

  let month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : `0${month}`;

  let day = date.getDate().toString();
  day = day.length > 1 ? day : `0${day}`;

  return `${day}/${month}/${year}`;
};
